import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Carrier } from '../../../../../backend/src/carriers/entities/carrier.entity';
import { NotificationService } from '../../notification/notification.service';

/**
 * Szállító létrehozás / szerkesztés — Stokker modál (inline overlay,
 * a design stk-modal stílusával; az edit-user mintájára).
 */
@Component({
  selector: 'app-edit-carrier',
  templateUrl: './edit-carrier.component.html',
  styleUrl: './edit-carrier.component.scss'
})
export class EditCarrierComponent implements OnInit {

  @Input() carrier: Carrier | null = null;
  @Output() closed = new EventEmitter<void>();
  @Output() saved = new EventEmitter<Carrier>();

  name = '';
  url = '';
  isSaving = false;

  constructor(
    private http: HttpClient,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.name = this.carrier?.name || '';
    this.url = this.carrier?.url || '';
  }

  get isNew(): boolean {
    return !this.carrier?.id;
  }

  get title(): string {
    return this.isNew ? 'Új szállító hozzáadása' : 'Szállító szerkesztése';
  }

  get canSave(): boolean {
    return this.name.trim().length >= 2 && !this.isSaving;
  }

  cancel() {
    this.closed.emit();
  }

  stop(event: Event) {
    event.stopPropagation();
  }

  save() {
    const name = this.name.trim();
    if (name.length < 2) {
      this.notificationService.show('Név kötelező (legalább 2 karakter)!', 'warning');
      return;
    }
    this.isSaving = true;
    const body: { id?: number; name: string; url: string } = {
      name,
      url: this.url.trim()
    };
    if (this.carrier?.id) {
      body.id = this.carrier.id;
    }
    this.http.post<Carrier>('carriers', body).subscribe((carrier) => {
      this.notificationService.show('Szállító sikeresen mentve!', 'success');
      this.saved.emit(carrier);
    }, e => {
      this.notificationService.show(`Hiba a szállító mentése során! Részletek: ${e.message}`, 'danger');
      this.isSaving = false;
    });
  }
}
